// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".partner-item-container[data-v-99fbe7fc]{width:100%;margin:168px 0}.wrap[data-v-99fbe7fc]{margin-left:40px;display:flex;justify-content:space-between}.poster[data-v-99fbe7fc]{width:48%}.poster img[data-v-99fbe7fc]{width:100%;-o-object-fit:contain;object-fit:contain}.description-box[data-v-99fbe7fc]{width:50%}.description-box span[data-v-99fbe7fc]{display:block;font-size:24px;font-weight:700}", ""]);
// Exports
module.exports = exports;
